<div class="row">
  <div class="col-12 col-md-6">
    <hs-radio-group-filter
      [radioFormControl]="isReconciledForm"
      label="Is Reconciled"
    ></hs-radio-group-filter>
    <hs-radio-group-filter
      [radioFormControl]="isTradingReconciledForm"
      label="Is Trading Reconciled"
    ></hs-radio-group-filter>
    <hs-radio-group-filter
      [radioFormControl]="hasOmegaDateForm"
      label="Has Omega Timestamp"
    ></hs-radio-group-filter>
    <hs-radio-group-filter
      [radioFormControl]="hasWaitingIssuesForm"
      label="Has Waiting Issues"
    ></hs-radio-group-filter>
    <hs-radio-group-filter
      [radioFormControl]="hasFoundIssuesForm"
      label="Has Found Issues"
    ></hs-radio-group-filter>
    <hs-radio-group-filter
      [radioFormControl]="hasTradingReconTimestampForm"
      label="Has Trading Recon Timestamp"
    ></hs-radio-group-filter>
    <hs-radio-group-filter
      [radioFormControl]="includeNonReconcilingAccounts"
      label="Include Non-Reconciling Accounts"
      [excludeBoth]="true"
    ></hs-radio-group-filter>
  </div>
  <div class="col">
    <nf-form-control
      label="Parent Client IDs"
      compact="compact"
      hint="Comma separated list of parent client ids. e.g. 1,2,3"
    >
      <input
        type="text"
        [formControl]="parentClientIdForm"
        placeholder="1,2,3"
      />
    </nf-form-control>
    <nf-form-control
      label="Aggregate IDs"
      compact="compact"
      hint="Comma separated list of aggregate account ids. e.g. 1,2,3"
    >
      <input type="text" [formControl]="aggregateIdForm" placeholder="1,2,3" />
    </nf-form-control>
    <nf-form-control label="Recon Date" compact="compact" data-cy="recon-date">
      <nf-datepicker
        [formControl]="reconDateForm"
        [format]="dateFormat"
        [placeholder]="dateFormat"
      >
      </nf-datepicker>
    </nf-form-control>
    <hs-security-filter
      (securityFilterForm)="updateSecurityFilter($event)"
      [security]="context?.advancedFilters?.security?.securityIdentifier"
      [currentlyHeld]="context?.advancedFilters?.security?.currentlyHeld"
    ></hs-security-filter>
  </div>
</div>
